import { HttpHeaders } from '@angular/common/http';

export class Pagination {
  count!: number;
  limit!: number;
  page!: number;

  constructor(headers?: HttpHeaders) {
    if (headers) {
      this.count = Number(headers.get('x-pagination-count'));
      this.limit = Number(headers.get('x-pagination-limit'));
      this.page = Number(headers.get('x-pagination-page'));
    }
  }
}
